module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/placeholder-2b405124417939b49aac4d39e9ba711c.svg";